<template>
  <b-container class="staffer" style="padding: 0;">
    <table cellpadding="0" cellspacing="0" style="width: 99%;">
      <tbody>
        <tr>
          <td class="ncut-base-form-text" style="width:5em;">角色：</td>
          <td class="ncut-base-form-ipt" style="width:12em;">
            <b-form-select label-for="input-1" tabindex="1" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
              placeholder="請選擇角色"
              v-model="queryInfo.type"
              @change="clearData()"
              required>
              <b-form-select-option 
                v-for="item in roleLst"
                :key="item.text1"
                :value="item.text1">{{item.text2}}</b-form-select-option>
            </b-form-select>
          </td>
          <td class="ncut-base-form-ipt">
            &nbsp;&nbsp;<b-button variant="outline-primary"
                @click="getClerkList()"
                v-if="queryInfo.type>0"><b-icon icon="search"/>&nbsp;{{$t('message.Query_cmd')}}</b-button>&nbsp;&nbsp;                
            <b-button variant="success" tabindex="10"
              @click="save()"
                v-if="(clerkInfo!=null)"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
          </td>
        </tr>
        <tr v-show="(clerkInfo!=null) && (clerkInfo.length>0)">
          <td colspan="5" class="ncut-base-form-ipt" style="padding: 0.1em 0.3em;">              
            <b-row style=" padding: 0.1em 0;">        
              <b-col sm="7" style=" background: white;"> 
                <b-form-input id="input-small" size="sm" placeholder="輸入關鍵字進行單位過濾"
                  v-model="filterText"></b-form-input>
                <div class="template-div-scroll template-maxh-30em" style="border-style:ridge; padding: 0.5em; background: white; overflow: auto; max-height: 68vh;">
                  <img src="@/assets/images/ic_domain_black_18dp.png" style="height: 1.375rem; padding: 0px 0.25rem 0 0;" /><b>{{setting.sysTitle[0].codeName}}</b>&nbsp;
                  <table style="width: 99%;" 
                    v-for="(items, pIndex) in filteredCars" 
                    :key="items.id" :index="items.id" :name="items.id"
                    @click="items.checked=!items.checked">
                    <tr style="line-height:1rem;">
                      <td style="width: 1.25rem; padding: 0; margin: 0;">
                        <img class="tools-btn" src="@/assets/images/treeLine4.gif" 
                          v-if="((clerkInfo.length-1) == pIndex) && !items.checked" />
                        <img class="tools-btn" src="@/assets/images/treeLine6.gif" 
                          v-if="((clerkInfo.length-1) == pIndex) && items.checked" />
                        <img class="tools-btn" src="@/assets/images/tminus2.gif" 
                          v-if="((clerkInfo.length-1) > pIndex) && !items.checked" />
                        <img class="tools-btn" src="@/assets/images/tminus1.gif" 
                          v-if="((clerkInfo.length-1) > pIndex) && items.checked" />
                      </td>
                      <td style="text-align:left;">
                        <a href="#" style="color:black;">
                          <img class="tools-btn" src="@/assets/images/home3.gif" />{{items.label}}
                        </a>&nbsp;
                      </td>
                    </tr>
                    <tr v-show="items.checked">
                      <td colspan="2">
                        <table style="width: 99%; ">
                          <tbody>
                            <tr style="line-height:1rem;"
                              v-for="(node, index) in items.children"
                              :key="setName('k', pIndex, index, node.id)" :name="setName('n', pIndex, index, node.id)" >
                              <td style="width: 1.25rem; padding: 0; margin: 0;">
                                <img class="tools-btn" src="@/assets/images/treeLine3.gif"
                                  v-if="(clerkInfo.length-1) > pIndex" />
                                <img class="tools-btn" src="@/assets/images/blank.gif" 
                                  v-else />
                              </td>
                              <td>
                                <table>
                                  <tr>
                                    <td>
                                      <img class="tools-btn" src="@/assets/images/treeLine2.gif" 
                                        v-if="index == (items.children.length - 1)" />
                                      <img class="tools-btn" src="@/assets/images/treeLine.gif" 
                                        v-else />&nbsp;
                                    </td>
                                    <td>
                                      <a href="#" style="color:black;"
                                        @click="setSelectedItem(pIndex, index)">
                                        <img class="tools-btn" src="@/assets/images/user3.gif" />{{node.label}}
                                      </a>&nbsp;
                                    </td>
                                    <td>
                                      <b-form-checkbox name="check-button"
                                        v-model="node.checked"
                                        v-if="!node.isDisabled"
                                        :disabled="node.isDisabled"
                                        @change="checkSelectedItem(1, pIndex, index)" />
                                      <span style="font-size: small; font-weight: bolder; color: #1e131d;" v-else>(已設定)</span>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
              </b-col>
              <b-col sm="5" style="background:white; padding: 0; min-height: 20em;">
                <span style="position: relative; display: flex; flex-direction: column; min-width: 0; word-wrap: break-word; background-color: #fff; background-clip: border-box; border: 1px solid rgba(0, 0, 0, 0.125); border-radius: 0.25rem;">
                  <h5 style="padding: 0.5rem 1rem; font-weight: bolder;"><b-icon icon="card-checklist" scale="2" variant="success"/>&nbsp;&nbsp;{{currTitle}}</h5>
                  <div class="set_div">
                  <ol style="padding-inline-start: 1.25rem;">
                    <li v-for="(o, index) in nameInfo" :key="'u'+index" class="text item" style="padding: 0.1875rem 0;">
                      <i class="el-icon-caret-right"></i><font style="background:#f9f4dc;">{{o.nm}}</font>&nbsp;&nbsp;
                      <span :title="'設定'+(queryInfo.type=='2'?'系科別':'學院')" v-show="['2','4'].indexOf(queryInfo.type) > -1">
                        <b-button id="btn-target-1" variant="outline-primary" style="padding: 0 0.0625rem;"
                          @click="showModal(o)" v-show="o.sId > 0"
                          v-b-toggle.sidebar-right><b-icon icon="diagram3" style="width: 0.875rem;"></b-icon></b-button>
                      </span>&nbsp;
                      <span title="移除" style="cursor: pointer;" @click="removeNote(index)"><b-icon icon="x-circle" scale="1" variant="danger"/></span>
                    </li>
                  </ol>
                  </div>
                </span>
              </b-col>
            </b-row>
          </td>
        </tr>             
      </tbody>
    </table>
    
    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認修改?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM">取消修改</b-button>
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM">修改確認</b-button>
    </b-modal>
  </b-container>
</template>

<script>
import * as tools from '@/tool';
export default {
  name: 'staffer',
  data () {
    return {
      filterText: '',
      value: null,
      queryInfo: {
        eId: 0,
        type: 0,
        groupID: '',
        dptcdID: 0,
      },
      clerkInfo: null,
      deptList: null,
      nameInfo: [],
      roleLst: [],
      dtInfo: null,
      editId: 0,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      changeFlag: false
    }
  },
  // watch: {
  //   filterText(val) {
  //       this.$refs.tree.filter(val);
  //   }
  // },
  computed: {
    sysId () {
        return this.$store.getters.getSysId
    },
    user () {
      return this.$store.state.user
    },
    setting () {
      return this.$store.getters.getSetting
    },
    currTitle() {
      var ret = '';
      if (!tools.isNull(this.roleLst)) {          
        var len = this.roleLst.length;
        for (var i = 0; i < len; i++) {
          if (this.roleLst[i].text1==this.queryInfo.type) {
            ret = this.roleLst[i].text2;
            break;
          }
        }
      }
      return ret;
    },
  	filteredCars: function(){ 
      var cars = [];
      if (!tools.isNull(this.clerkInfo)) {        
        if ( !tools.isEmpty(this.filterText)) {
          cars = this.clerkInfo.filter(car => { 
            if (car.label.includes(this.filterText)) {
              return true;
            } else if (null != car.children) {
              var len = car.children.length;
              for (var i = 0; i < len; i++) {
                if (car.children[i].label.includes(this.filterText)) {  
                  return true;
                }
              }
            }
            return false;
          });
        } else {
          cars = this.clerkInfo;
        }
      }
      return cars;
    }
  },
  methods: {
    showModal(item) {
      this.dtInfo = this.clerkInfo[item.iIdx].children[item.jIdx].dtInfo;
      this.editId = item.sId;
      this.$refs['deptMt'].show();
    }, 
    hideModal() {
      this.$refs['deptMt'].hide();      
    },
    removeNote(idx) {
      
      var len1 = this.clerkInfo.length;
      var level1 = -1;
      var level2 = -1;
      for (var i = 0; (i < len1) && (level1 < 0); i++) {
        if (!tools.isNull(this.clerkInfo[i].children)) {            
          var len2 = this.clerkInfo[i].children.length;
          for (var j = 0; (j < len2) && (level2 < 0); j++) {
            if (this.clerkInfo[i].children[j].id==this.nameInfo[idx].id) {
              this.clerkInfo[i].children[j].checked = false;
              level1 = i;
              level2 = j;
            }
          }
        }
      }
      this.nameInfo.splice(idx, 1);
    },
    clearData() {
      this.clerkInfo = null;
      this.deptList  = null;
      this.nameInfo  = [];
    },
    setName(val1, val2, val3, val4) {
      return tools.stringFormat("{0}{1}{2}{3}", val1, val2, val3, val4);
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      var len1 = this.clerkInfo.length;
      var level1 = -1;
      var level2 = -1;
      for (var i = 0; (i < len1) && (level1 < 0); i++) {
        if (!tools.isNull(this.clerkInfo[i].children)) {            
          var len2 = this.clerkInfo[i].children.length;
          for (var j = 0; (j < len2) && (level1 < 0); j++) {
            if (this.clerkInfo[i].children[j].id==data.id) {
              this.clerkInfo[i].children[j].checked = !data.checked;
              level1 = i;
              level2 = j;
            }
          }
        }
      }
      if ((-1 < level1) && (-1 < level2)) {          
        this.checkSelectedItem((data.checked?1:0), level1, level2);
      }
    },
    checkSelectedItem(flag, level1, level2) {      
        var format = "{0} ({1})";

        if (0 == flag) {
            this.nameInfo = [];
            for (var i = 0; i < this.clerkInfo.length; i++) {
                for (var j = 0; j < this.clerkInfo[i].children.length; j++) {
                    if (true == this.clerkInfo[i].children[j].checked) {
                      var tmpObj = this.clerkInfo[i].children[j];
                      this.nameInfo.push({ 
                          sId   : tmpObj.sId, 
                          id    : tmpObj.id, 
                          nm    : tmpObj.label,
                          dtInfo: tmpObj.dtInfo, 
                          iIdx  : i,
                          jIdx  : j
                      });
                    }
                }
            }
        } else {
            var obj = { 
              id: this.clerkInfo[level1].children[level2].id, 
              nm: this.clerkInfo[level1].children[level2].label,
              dtInfo: [this.queryInfo.type=='2'? this.clerkInfo[level1].children[level2].groupId: this.clerkInfo[level1].children[level2].deptName], 
              iIdx: level1,
              jIdx: level2
            };
            if (true == this.clerkInfo[level1].children[level2].checked) {
                this.nameInfo.push(obj);
            } else {
                var idLst = [];
                for (var i = 0; i < this.nameInfo.length; i++) {
                    if (this.nameInfo[i].id == this.clerkInfo[level1].children[level2].id) {
                        idLst.push(i);
                    }
                }
                if (0 < idLst.length) {
                    var len = idLst.length;
                    for (var i = len - 1; i >= 0; i--) {
                        this.nameInfo.splice(idLst[i], 1);
                    }
                }
            }
        }
        this.changeFlag = true;
    },
    getClerkList() {
      var vm = this
      this.queryInfo.sysId = this.sysId;
      this.filterText = '';
      this.$http.put('./WebApi/Setting/GetClerkTree', this.queryInfo)
                .then((response) => { 
                  if (!tools.isNull(response.data)) {
                    var select = [];
                    vm.clerkInfo = response.data;
                        
                    vm.checkSelectedItem(0, 0, 0);     
                    var len1 = vm.clerkInfo.length;
                    for (var i = 0; i < len1; i++) {
                      var len2 = vm.clerkInfo[i].children.length;
                      for (var j = 0; j < len2; j++) {
                        if (vm.clerkInfo[i].children[j].checked) {
                          vm.clerkInfo[i].checked = true;
                          select.push(vm.clerkInfo[i].children[j].id);
                          vm.checkSelectedItem(0, i, j);
                        }
                      }
                    }
                    // setInterval(this.setTree, 60000);
                    // if (!tools.isNull(vm.$refs.tree)) {       
                    //   vm.$refs.tree.setCheckedKeys(select);       
                    // }
                  }
                })
                .catch(function (error) {
                  tools.showAlert(vm, 'danger', '網路連線失敗' + error);
                })
      //this.queryDept();
    },
    queryDept () {
      var vm = this;
      var url = tools.stringFormat("./WebApi/Setting/GetDeptList/{0}", this.queryInfo.type);
      this.$http.get(url)
                .then((response) => { 
                  if (!tools.isNull(response.data)) {
                    vm.deptList = response.data;
                  }
                })
                .catch(function (error) {
                  tools.showAlert(vm, 'danger', '網路連線失敗' + error);
                })

    },
    checkSaveData () {
        var ret = []; 
        var len1 = this.clerkInfo.length;
        for (var i = 0; i < len1; i++) {
          var len2 = this.clerkInfo[i].children.length;
            for (var j = 0; j < len2; j++) {
                if (this.clerkInfo[i].children[j].checked) {
                    ret.push(this.clerkInfo[i].children[j]);
                }
            }
        }
        return ret;
    },
    cancalRM() {
      this.$refs['q-modal'].hide();
    },
    confirmRM() {
      this.$refs['q-modal'].hide();
      var tObj = this.checkSaveData();
      if (!tools.isNull(tObj) && (0 < tObj.length)) {
        var vm = this
        var data = {
                      uId : this.user.id,
                      type   : this.queryInfo.type,
                      sysId  : this.sysId,
                      info   : tObj
                    };
                    
        this.$http.put('./WebApi/Setting/SetClerkTree', data)
          .then((response) => {
            if (response.data === true) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功');
              vm.changeFlag = false;
              vm.getClerkList();
            }
            else {
              tools.showAlert(vm, 'danger', '存檔失敗');
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error);
          })
      } else {
        tools.showAlert(this, 'danger', '請至少選擇一筆資料');
      }
    },
    save() {
      this.$refs['q-modal'].show();
    },
    getRoleSet: function () {
      return this.$http
                 .get('./WebApi/Setting/GetRoleItem/'.concat(this.sysId).concat('/97'));
    }
  },
  created () {
    //console.log('== Staffer ==');
    var vm = this
    this.$http.all([this.getRoleSet()])
      .then(vm.$http.spread(function (data1) {
        vm.roleLst = data1.data
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.set_div
{
  padding: 0.5em;
  background: white;
  overflow: auto;
  max-height: 66vh;
}
</style>
